import ApiService from "../utils/ApiService";
import { getEnvironment } from "../utils/EnvConfig";

// return promise for getting Paypal token
export const getPaypalToken = async (params = {}, headers = {}) => {
  const env = getEnvironment();
  return await ApiService.get(
    { ...params, apiUrl: env.brightspeedApi },
    { headers: headers }
  );
};


export const paypalTokenDetails = async (
  params = {},
  body = {},
  headers = {}
) => {
  const env = getEnvironment();
  return await ApiService.post(
    { ...params, apiUrl: env.brightspeedApi },
    body,
    { headers: headers }
  );
};